import React from 'react';
import { EventType } from "../../../store/alerts/types";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { SettingsState } from "../../../store/settings/types";
import MyDate from "../../../utils/MyDate";
import { chooseService } from '../../../utils';

const {CONFIG} = window;


interface Props {
  events: EventType[],
  selectedEvent: EventType | null,
  handler: (e: EventType | null) => void
}

const AlertsTableContentComponent: React.FC<Props> = ({events, handler, selectedEvent}) => {
  const selectedID = selectedEvent ? selectedEvent.id : null;
  const {isLocalTime} = useSelector<ApplicationState, SettingsState>(state => state.settings);

  return (
    <div className='alerts-table__content'>
      <div className='scroll'>
        {
          events.map((event) => {
            const {id, prio, when, what, where} = event;
            let alertColor = CONFIG.alerts.colorsPriority[prio];

            return (
              <div key={id}
                   id={`alerts-${id}`}
                   className={
                     selectedID === id
                       ? 'alerts-table-content__row selected'
                       : 'alerts-table-content__row'
                   }
                   onClick={() => handler(event === selectedEvent ? null : event)}
              >
                <div className='alerts-table-content__item priority'
                     style={{background: alertColor, color: '#000000'}}
                >{prio}</div>
                <div className='alerts-table-content__item time'>
                  {
                    chooseService(
                      () => isLocalTime ? new MyDate(when).toLocaleString() : new MyDate(when).to24String(),
                      () => isLocalTime ? new MyDate(parseInt(when)).toLocaleString() : new MyDate(parseInt(when)).to24String()
                    )
                  }
                </div>
                <div className='alerts-table-content__item rule'>{what}</div>
                <div className='alerts-table-content__item camera'>{where}</div>
              </div>
            )
          })
        }
      </div>
    </div>
  );
};

export default AlertsTableContentComponent;